module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABQklEQVQ4T83Ty04CMRgF4PN3XsCVN9R4SQSiUQM/sHLje/sAkzmExCve4wU06isMNZiZppQBWbBwdk3Tr6enHcGcPpmTg38OkbwAsKCqa7McudPpbKZp+mSMKbmjkTwFcJIBvb+wOI63oih6zDcc6YjkO4DlbLKvqqWiZEmSbIvIQz5njDkaKzvA3lV11cdCREQO6/X6WeGtkewDWMkAh5HcAXDvwQeqej4cT7x+kj0AeZoPETm21t7lyGAw2G82m5eFHYV9BJibDpGpifJVJN8AuNKNMXu1Wu0q3HTqy47jeDeKoptg0aeqLs0MJUlSFpGut2CYLH+oY1hhogKkqqpdkq8e9qWqixPLJlkBcO0l+UW8zl4ArGdjh40karfbVWutK9JaW2k0GmFHIPkMYMPHHBQiaZqWW63W7aSfN8C+fwAemYfitIVAlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 136